import axios from "../common/config/axios";

class SupportCodeService {
    static getCurrentCode() {
        return axios.get("support/code", { timeout: 15000 }).then((response) => {
            const code = response.data && response.data.data && response.data.data.support_code;
            if (!code) {
                throw new Error("Support code is unavailable");
            }

            return code;
        });
    }

    static rotate() {
        return axios.post("support/code/rotate", null, { timeout: 15000 }).then((response) => {
            const code = response.data && response.data.data && response.data.data.support_code;
            if (!code) {
                throw new Error("Support code is unavailable");
            }

            window.dispatchEvent(new CustomEvent("support-code-updated", { detail: code }));

            return code;
        });
    }

    static async copyToClipboard(code) {
        if (!code) {
            throw new Error("Support code is unavailable");
        }

        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(code);
            return;
        }

        const textArea = document.createElement("textarea");
        textArea.value = code;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);

        try {
            textArea.focus();
            textArea.select();
            if (!document.execCommand("copy")) {
                throw new Error("Clipboard copy failed");
            }
        } finally {
            document.body.removeChild(textArea);
        }
    }
}

export default SupportCodeService;
